import React, { Component } from "react"

import Loader from "dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent"
import Validator from "../../../Components/FormComponent/Validator"
import HSGModalComponent from "../../HSGModalComponent/HSGModalComponent"

import Countdown from "react-countdown-now"
import OtpInput from "react-otp-input"

import "./DialogForgotPassword.css"

import footerImage from "./Assets/dialog-footer.svg"

const MAP_SCREENS = {
    RECOVER: 0,
    OPTION: 1,
    OTP: 2,
    MAGIC_LINK: 3,
    RESET_PASSWORD: 4,
}

class DialogForgotPassword extends Component {
    constructor(props) {
        super(props)

        this.initialState = {
            username: "",
            errorUsername: "",

            OTP: "",
            errorOTP: "",

            showProgress: false,

            OTPSend: false,
            magicLinkSent: false,

            resendOTPEnable: false,
            resendOTPTime: Date.now() + 30000,

            currentScreen: MAP_SCREENS.RECOVER,

            currentEmail: null,
            currentPhone: null,
            currentUserId: null,
            currentMagicLink: null,
            currentUsername: null,

            password: "",
            confirmPassword: "",
        }

        this.state = this.initialState
    }

    componentDidMount() {
        if (this.props.type && this.props.type === MAP_SCREENS.RESET_PASSWORD) {
            this.setState({ currentScreen: MAP_SCREENS.RESET_PASSWORD })
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.signUpStatus && newProps.signUpStatus !== this.props.signUpStatus) {
            const { userEmail, userPhone, userId, magicLink, username } = newProps.signUpStatus || {}

            let sendMagicLink, sendOTP

            let updateElement = {
                currentEmail: userEmail,
                currentPhone: userPhone,
                currentUserId: userId,
                currentMagicLink: magicLink,
                currentUsername: username,
                showProgress: false,
            }

            if (userEmail && userPhone) {
                updateElement = { ...updateElement, currentScreen: MAP_SCREENS.OPTION }
            } else if (userEmail) {
                updateElement = { ...updateElement, currentScreen: MAP_SCREENS.OPTION }
                // sendMagicLink = true
            } else if (userPhone) {
                updateElement = { ...updateElement, currentScreen: MAP_SCREENS.OTP }
                sendOTP = true
            } else {
                updateElement = { ...updateElement, errorUsername: "Username does not exist." }
            }

            this.setState(updateElement, ()=> {
                if ( sendOTP ) {
                    this.sendOTP()
                }
                if ( sendMagicLink ) {
                    this.sendMagicLink()
                }
            })
        }

        if (newProps.loginStatus && newProps.loginStatus !== 200 && !!!newProps.isAuthenticated && this.state.OTPSend && !newProps.isLoading) {
            this.setState({ errorOTP: "Invalid OTP." })
        }

        if (newProps.show && this.props.show !== newProps.show) {
            if (newProps.type && newProps.type === MAP_SCREENS.RESET_PASSWORD) {
                this.setState({ ...this.initialState, currentScreen: MAP_SCREENS.RESET_PASSWORD })
            }else {
                this.setState({ ...this.initialState, currentScreen: MAP_SCREENS.RECOVER })
            }
        }
    }

    sendMagicLink() {
        const { currentEmail, currentMagicLink, username } = this.state

        this.setState({
            magicLinkSent: true,
            currentScreen: MAP_SCREENS.MAGIC_LINK,
        })
        this.props.sendMagicLink(currentMagicLink, currentEmail, username)
    }

    sendOTP() {
        const { currentEmail, currentPhone, currentUserId } = this.state

        this.setState({
            resendOTPEnable: false,
            resendOTPTime: Date.now() + 30000,
            OTPSend: true,
            currentScreen: MAP_SCREENS.OTP,
        })
        this.props.sendOtp(currentPhone, currentEmail, currentUserId)
    }

    hideEmail(userEmail) {
        let email = userEmail && userEmail.trim() ? userEmail : ""
        let hidden = ""
        let startFlag = true
        for (let i = 0; i < email.length; i++) {
            if (i === 0) {
                hidden += email[i]
                startFlag = false
            } else if (email[i] === "@") {
                hidden += email[i]
            } else {
                hidden += "*"
            }
        }

        return hidden
    }

    hidePhone(userPhone) {
        let phone = userPhone && userPhone.trim() ? userPhone : ""
        let hidden = ""
        let startFlag = true
        for (let i = 0; i < phone.length; i++) {
            if (i < 5) {
                hidden += phone[i]
                startFlag = false
            } else {
                hidden += "*"
            }
        }

        return hidden
    }

    dialogFooter = () => (
        <div className="row right">
            <img className="hsg-forgot-dialog-footer-image" src={footerImage} />
        </div>
    )

    dialogBodyRecover = () => {
        return (
            <div>
                <div className="hsg-forgot-dialog-body-recover-root center">
                    <div className="hsg-forgot-dialog-input-group hsg-forgot-dialog-body-recover-input">
                        <input
                            name="dialogBodyRecover"
                            className="hsg-forgot-dialog-input hsg-forgot-dialog-body-recover-height"
                            id="dialogBodyRecover"
                            placeholder=""
                            type={"text"}
                            value={this.state.username || ""}
                            onChange={(e) =>
                                this.setState({
                                    username: e.target.value,
                                    errorUsername: !Validator.indianPhoneValidator(e.target.value)
                                        ? undefined
                                        : !Validator.checkEmail(e.target.value)
                                        ? undefined
                                        : "Not a valid username",
                                })
                            }
                        />
                        <div className="hsg-forgot-dialog-body-recover-input padding-top-8">
                            <div className="hsg-forgot-dialog-body-recover-content">Don’t remember your registered email address or phone number?</div>
                            <div className="hsg-forgot-dialog-body-recover-link"><a className="hsg-forgot-dialog-body-recover-link" href="https://www.healthsetgo.com/contact-us" target="_blank">Help Me!</a></div>

                            <div className="hsg-error padding-0">{this.state.errorUsername}</div>
                        </div>
                    </div>
                    <button
                        className="hsg-btn hsg-forgot-dialog-button-recover hsg-forgot-dialog-body-recover-height"
                        onClick={() => {
                            if (this.state.username && this.state.username.trim() && !this.state.errorUsername) {
                                this.setState({ showProgress: true })
                                this.props.fetchUserSignUpStatus(this.state.username)
                            } else {
                                this.setState({ errorUsername: this.state.errorUsername || "Username cannot be blank" })
                            }
                        }}
                    >
                        Search
                    </button>
                </div>
                {/* <div>{this.dialogFooter()}</div> */}
            </div>
        )
    }

    dialogBodyOption = () => {
        return (
            <div>
                <div className="col-xs-12 center">
                    <button className="hsg-btn hsg-forgot-dialog-button-option" onClick={() => this.sendMagicLink()}>
                        Login using Magic Link
                    </button>
                </div>
                <div className="col-xs-12  center">
                    <button className="hsg-btn hsg-forgot-dialog-button-option" onClick={() => this.sendOTP()}>
                        Reset Password
                    </button>
                </div>
            </div>
        )
    }

    dialogBodyOTP = () => {
        return (
            <div>
                <div className="hsg-forgot-dialog-body-recover-root center">
                    <div className="hsg-forgot-dialog-input-group hsg-forgot-dialog-body-recover-input">
                        <div className="hsg-forgot-dialog-body-recover-input padding-top-8">
                            <div className="hsg-forgot-dialog-body-otp-content">Please fill in the received OTP below.</div>
                        </div>
                        <OtpInput
                            value={this.state.OTP}
                            onChange={(otp) => {
                                this.setState({
                                    OTP: otp,
                                    errorOTP: null,
                                })

                                if (otp && otp.length === 4) {
                                    this.props.loginUser({ username: this.state.username, otp: otp })
                                }
                            }}
                            numInputs={4}
                            separator={<span className="hsg-forgot-dialog-body-otp-span">-</span>}
                            inputStyle="hsg-forgot-dialog-input-otp"
                            containerStyle={{ justifyContent: "center" }}
                        />
                        <div className="hsg-forgot-dialog-body-recover-input padding-top-8">
                            <div className="hsg-forgot-dialog-body-otp-content">
                                {this.state.resendOTPEnable ? (
                                    <div className="right">
                                        <text className="cursor-pointer" onClick={() => this.sendOTP()}>
                                            Resend code?
                                        </text>
                                    </div>
                                ) : (
                                    <div className="right">
                                        <Countdown
                                            date={this.state.resendOTPTime}
                                            intervalDelay={1}
                                            precision={0}
                                            renderer={(props) => {
                                                if (props.minutes === 0 && props.seconds === 0 && !this.state.resendOTPEnable) {
                                                    this.setState({
                                                        resendOTPEnable: true,
                                                    })
                                                }
                                                return (
                                                    <div className="right">
                                                        {`Resend link will be activated in ${props.minutes}:${
                                                            props.seconds && props.seconds.toString().length > 1 ? props.seconds : "0" + props.seconds
                                                        }`}
                                                    </div>
                                                )
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="hsg-forgot-dialog-body-recover-input padding-top-8">
                            <div className="hsg-error padding-0">{this.state.errorOTP}</div>
                        </div>
                    </div>
                </div>
                {/* <div>{this.dialogFooter()}</div> */}
            </div>
        )
    }

    dialogBodyMagicLink = () => {
        return <div></div>
    }

    eyeIconShowPassword = (value) =>
        this.state[value] ? (
            <i
                className="fa fa-eye-slash hsg-forgot-dialog-body-reset-password-eye"
                onClick={() => this.setState((pState) => ({ [value]: !pState[value] }))}
                aria-hidden="true"
            ></i>
        ) : (
            <i
                className="fa fa-eye hsg-forgot-dialog-body-reset-password-eye"
                onClick={() => this.setState((pState) => ({ [value]: !pState[value] }))}
                aria-hidden="true"
            ></i>
        )

    dialogBodyResetPassword = () => {
        return (
            <div>
                <div className="hsg-forgot-dialog-body-reset-password-root center">
                    <div className="hsg-forgot-dialog-input-group hsg-forgot-dialog-body-recover-input margin-bottom-16">
                        <input
                            name="dialogBodyResetPassword"
                            className="hsg-forgot-dialog-input hsg-forgot-dialog-body-recover-height"
                            id="dialogBodyResetPassword"
                            placeholder="Create Password"
                            type={this.state.showPassword ? "text" : "password"}
                            value={this.state.password || ""}
                            onChange={(e) =>
                                this.setState({
                                    password: e.target.value,
                                    errorPassword:
                                        Validator.required(e.target.value) ||
                                        Validator.minValue(4, "Password should be 4 character or more")((e.target.value && e.target.value.length) || 0),
                                    errorConfirmPassword: this.state.confirmPassword
                                        ? Validator.required(this.state.confirmPassword) ||
                                          (this.state.confirmPassword !== e.target.value ? "Password do not match" : "")
                                        : undefined,
                                })
                            }
                        />
                        {this.eyeIconShowPassword("showPassword")}
                        <div className="hsg-error padding-0">{this.state.errorPassword}</div>
                    </div>
                    <div className="hsg-forgot-dialog-input-group hsg-forgot-dialog-body-recover-input margin-bottom-16">
                        <input
                            name="dialogBodyResetPasswordConfirm"
                            className="hsg-forgot-dialog-input hsg-forgot-dialog-body-recover-height"
                            id="dialogBodyResetPasswordConfirm"
                            placeholder="Confirm Password"
                            type={this.state.showConfirmPassword ? "text" : "password"}
                            value={this.state.confirmPassword || ""}
                            onChange={(e) =>
                                this.setState({
                                    confirmPassword: e.target.value,
                                    errorConfirmPassword:
                                        Validator.required(e.target.value) || (e.target.value !== this.state.password ? "Password do not match" : ""),
                                })
                            }
                        />
                        {this.eyeIconShowPassword("showConfirmPassword")}
                        <div className="hsg-error padding-0">{this.state.errorConfirmPassword}</div>
                    </div>
                    <button
                        className="hsg-btn hsg-forgot-dialog-button-recover"
                        onClick={() => {
                            const { password, confirmPassword, errorPassword, errorConfirmPassword } = this.state

                            if (!errorConfirmPassword && !errorPassword && confirmPassword && password) {
                                this.props.changePassword(password)
                                this.props.onClose()
                            } else {
                                this.setState({
                                    errorPassword:
                                        Validator.required(password) ||
                                        Validator.minValue(4, "Password should be 4 character or more")((password && password.length) || 0),
                                    errorConfirmPassword: Validator.required(confirmPassword) || (confirmPassword !== password ? "Password do not match" : ""),
                                })
                            }
                        }}
                    >
                        Submit
                    </button>
                </div>
                {/* <div>{this.dialogFooter()}</div> */}
            </div>
        )
    }

    mapDialog = () => ({
        [MAP_SCREENS.RECOVER]: {
            head: "Recover Your Account",
            content: "Please enter your registered email address or phone number to search for your account.",
            body: this.dialogBodyRecover(),
        },
        [MAP_SCREENS.OPTION]: {
            head: "Recover Your Account",
            content: "How do you want to recover your account?",
            body: this.dialogBodyOption(),
        },
        [MAP_SCREENS.OTP]: {
            head: "Reset Password",
            content:
                this.state.currentEmail && this.state.currentPhone
                    ? `An OTP has been sent to your registered email address and phone number.`
                    : this.state.currentEmail
                    ? `An OTP has been sent to your registered email address.`
                    : `An OTP has been sent to your registered phone number.`,
            body: this.dialogBodyOTP(),
        },
        [MAP_SCREENS.MAGIC_LINK]: {
            head: "Recover Your Account",
            content: `We have sent you a Magic Link to log in to your account on ${this.hideEmail(
                this.state.currentEmail
            )}! For any further assistance, please feel free to Contact us.`,
            body: this.dialogBodyMagicLink(),
        },
        [MAP_SCREENS.RESET_PASSWORD]: {
            head: "Reset Password",
            content: "Please create a new password.",
            body: this.dialogBodyResetPassword(),
        },
    })

    dialogBody() {
        const current = this.mapDialog()[this.state.currentScreen]

        return (
            <div className="row">
                <div className="col-xs-12 center hsg-forgot-dialog-head margin-bottom-32 margin-top-24">{current.head}</div>
                <div className="col-xs-12 center hsg-forgot-dialog-content margin-bottom-48">{current.content}</div>
                <div className="col-xs-12 center">{current.body}</div>
                <div className="right">{this.dialogFooter()}</div>
            </div>
        )
    }

    render() {
        return (
            <HSGModalComponent
                show={this.props.show}
                onClose={() => this.props.onClose()}
                onHide={() => this.props.onHide()}
                showClose={this.props.hideClose ? false : true}
                body={this.dialogBody()}
            />
        )
    }
}

export default DialogForgotPassword
